import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import corevalue from "../../../images/core_value_new.png";
import { forgotPassword } from "../../../api/ApiConfig";
import "../../global/Global.css";
import "../../global/GlobalStyle.css";
import "./Forget.css";
import toast from "react-hot-toast";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleForgetSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      const userData = { email }; // 👈 pass as JSON object
      await forgotPassword(userData, (response) => {
        if (response.status == "success") {
          toast.success("Reset link sent to your email.");
          setEmail("");
        }
      });
    } catch (error) {
      toast.error(error.message || "Something went wrong.");
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div className="box-describe">
      <div className="box-describe-wrapper">
        {/* Left side view */}
        <div className="box-describe-left-view">
          <>
            <div className="title" style={{ fontSize: "28px" }}>
              Forgot Password?
            </div>
            <div>
              <div className="input-field-global-field">
                <label style={{ color: "#6E6E6E" }}>Email</label>
                <input
                  type="email"
                  id="Email"
                  placeholder="Eg: abc@example.com"
                  value={email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="button-design-container">
                <button
                  className="button-design"
                  type="submit"
                  //navigate="/reset-password"
                  onClick={handleForgetSubmit}
                >
                  Reset password
                </button>
              </div>
            </div>

            <div className="mt-3">
              <Link to="/" className="back-to-login mt-2">
                Back to Login
              </Link>
            </div>
          </>
        </div>

        {/* Right side form */}
        <div className="box-describe-form-right-view">
          <div className="content-container">
            <div className="">
              <h3 className="corevaluehead">Our Vision</h3>
              <p className="corevaluesubhead">
                To become a global IT Services and Solutions provider,
                delivering innovation-led best-in-class technology solutions by
                leveraging data, AI, and emerging technologies.
              </p>
            </div>
            {/* Conditionally render images */}
          </div>
          <div className="mt-4">
            <h3 className="corevaluehead">Our Mission</h3>
            <p className="corevaluesubhead">
              To co-engineer excellence for our customers with their
              transformation journey and in the process create value for all our
              stakeholders.
            </p>
          </div>

          <div className="mt-4">
            <img src={corevalue} alt="Illustration" className="img-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
